export default function ScreenshotFrame({ src, alt, caption, capture, testid }) {
  return (
    <figure data-testid={testid}>
      {src ? (
        <div className="clip-frame-sm overflow-hidden border border-white/10 bg-panel">
          <img
            src={src}
            alt={alt}
            loading="lazy"
            className="w-full object-cover transition-transform duration-700 hover:scale-[1.02]"
          />
        </div>
      ) : (
        <div
          className="flex min-h-[220px] flex-col items-center justify-center gap-3 rounded-xl border border-dashed border-white/20 bg-panel/60 p-8 text-center"
          data-testid={`${testid}-placeholder`}
        >
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-beam">
            Screenshot pending
          </span>
          <span className="max-w-sm font-mono text-xs leading-relaxed text-zinc-500">
            {capture}
          </span>
        </div>
      )}
      {caption && (
        <figcaption className="mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-600">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
